import { Global } from "@emotion/react";

const Fonts = () => {
  return (
    <Global
      styles={`
                /* nurtur kurye*/ 
                @font-face {
                    font-family: "Nurtur Text";
                    font-style: normal;
                    font-weight: 600;
                    src: url(/fonts/Kurye-SemiBold.otf)
                }
            `}
    />
  );
};

export default Fonts;
